import Gallery from "../modules/gallery/Gallery";

export const GalleryPage = () => {
  return <Gallery xs={12} md={3} lg={3} xss={12} mds={12} lgs={12}/>;
};
